var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-progress",class:{ 'c-progress--small': _vm.small, 'c-progress--rounded': _vm.rounded },style:({ backgroundColor: _vm.bgc })},[_c('div',{staticClass:"c-progress__value btn-primary",class:{
      'c-progress__value--small': _vm.small,
      'c-progress__value--rounded': _vm.rounded
    },style:({ width: _vm.convertedValue + '%', backgroundColor: _vm.colorProgress })})])}
var staticRenderFns = []

export { render, staticRenderFns }